"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FacebookSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,2 C12.8659961,2 16,5.13400391 16,9 C16,12.4939023 13.4402012,15.3898242 10.09375,15.9149609 L10.09375,11.0234375 L11.7248047,11.0234375 L12.0351562,9 L10.09375,9 L10.09375,7.68691211 C10.09375,7.13333789 10.3649316,6.59375 11.2345039,6.59375 L12.1171875,6.59375 L12.1171875,4.87109375 C12.1171875,4.87109375 11.3161113,4.734375 10.5502539,4.734375 C8.95130078,4.734375 7.90625,5.7034375 7.90625,7.4578125 L7.90625,9 L6.12890625,9 L6.12890625,11.0234375 L7.90625,11.0234375 L7.90625,15.9149609 C4.55979883,15.3898242 2,12.4939023 2,9 C2,5.13400391 5.13400391,2 9,2 Z" })));
};
FacebookSmall.displayName = 'FacebookSmall';
exports.default = FacebookSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FacebookSmall.js.map